import LogoIndoWhite from './logo-indo-white';
import LogoMimetikaWhite from './logo-mimetika-white';
import LogoConfig from './logo-config';
import LogoMenu from './logo-menu';
import LogoExit from './logo-exit';
import MiCorridor from './mi-corridor';
import LogoFormaCircleMenu from './logo-forma-circulo-menu';
import LogoWidr from "./logo-ov-white";

const icons = {
    LogoIndoWhite,
    LogoMimetikaWhite,
    LogoConfig,
    LogoMenu,
    LogoExit,
    MiCorridor,
    LogoFormaCircleMenu,
    LogoWidr
};

export default icons;
